import { render } from "./LeaderboardUserElement.vue?vue&type=template&id=0f05ae45&scoped=true"
import script from "./LeaderboardUserElement.vue?vue&type=script&lang=js"
export * from "./LeaderboardUserElement.vue?vue&type=script&lang=js"

import "./LeaderboardUserElement.vue?vue&type=style&index=0&id=0f05ae45&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f05ae45"]])

export default __exports__